
/* 
 * this function handle the preview update for widget setttings..
 */
function previewUpdateWidgetSettings (data) {
    console.log('previewUpdateWidgetSettings(): ', data);
    const env = this.env;
    env.appStore.updateWidgetSettings(data.settings);
}

export default previewUpdateWidgetSettings;
